class CookieDependencyContent {
    constructor(element, callbackConsentFn, callbackRevokedFn) {
        // flag to prevent revoke callback on load
        this.consentGivenOnce = false

        // content to protect
        this.originContent = element.querySelector('.js-cookie-dependency__content')

        // content to give user information required consent for given CookieGroup
        this.informationContent = element.querySelector('.js-cookie-dependency__message')

        // possible callback functions
        this.callbackConsentFn = callbackConsentFn
        this.callbackRevokedFn = callbackRevokedFn

        this.cssHideClass = 'hide-content'

        // set necessary active cookie group
        this.necessaryCookieGroup = element.dataset['cookieGroup']

        // initial check to decide if consent already given
        this.checkConsent()
    }

    /**
     * check if consent is given and show or hide origin content
     */
    checkConsent() {
        if (this.isConsentGiven()) {
            this.showOrigin()
        } else {
            this.hideOrigin()
        }
    }

    /**
     * check if cookie consent is given for current element and cookie group
     * @returns {boolean}
     */
    isConsentGiven() {
        const activeGroups = OnetrustActiveGroups.split(',')
        // Checks if activeGroups contain the necessary cookie group
        if (activeGroups !== undefined && !this.enabled && activeGroups.indexOf(this.necessaryCookieGroup) >= 0) {
            return true
        }
        return false
    }

    /**
     * show Origin content when cookie consent for group is given for this element
     */
    showOrigin() {
        this.originContent.classList.remove(this.cssHideClass)
        this.informationContent.classList.add(this.cssHideClass)
        // call consent callback fn
        if (this.callbackConsentFn && typeof this.callbackConsentFn == 'function') this.callbackConsentFn()

        // set flag to allow revoke CallbackFn
        this.consentGivenOnce = true
    }

    /**
     * hide Origin content when cookie consent for group is not given for this element
     */
    hideOrigin() {
        this.originContent.classList.add(this.cssHideClass)
        this.informationContent.classList.remove(this.cssHideClass)
        // call consent revoke fn
        if (this.consentGivenOnce === true && this.callbackRevokedFn && typeof this.callbackRevokedFn == 'function')
            this.callbackRevokedFn()
    }
}

/**
 * Initializes all CookieConsentContent elements on the page
 * @param configuration {Array}
 */
export default function initializeCookieDependencyContent(configuration) {
    if (typeof window.OneTrust !== 'undefined') {
        let contentWithCookieDependency = []

        //@var {CookieDependencyConfigurationObject} configurationObject
        configuration.forEach((configurationObject) => {
            let elements = document.querySelectorAll(configurationObject.selector)
            elements.forEach((element) => {
                contentWithCookieDependency.push(
                    new CookieDependencyContent(
                        element,
                        configurationObject.callbackConsentFn,
                        configurationObject.callbackRevokedFn
                    )
                )
            })
        })

        //Add the  changed event outside of the cookieConsent object, otherwise it doesn't work
        OneTrust.OnConsentChanged(() => {
            contentWithCookieDependency.forEach((content) => {
                // Add listener in case the user rejects or accepts
                content.checkConsent()
            })
        })
    } else {
        // This workaround was required since there seems to be no event firing, when CookieVendor is available
        // Please refactor if a better way is available
        setTimeout(function () {
            initializeCookieDependencyContent(configuration)
        }, 250)
    }
}
